import { render } from "./HomeCompanyInst.vue?vue&type=template&id=65270433&scoped=true"
import script from "./HomeCompanyInst.vue?vue&type=script&lang=js"
export * from "./HomeCompanyInst.vue?vue&type=script&lang=js"

import "./HomeCompanyInst.vue?vue&type=style&index=0&id=65270433&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65270433"]])

export default __exports__